import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, orderBy, Timestamp, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Helmet } from "react-helmet";
import Loading from '../components/loading';
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import { Randomcode } from '../components/rendom_code';
import { MdSearch, MdAdd, MdSettings, MdDisplaySettings, MdMoreHoriz, MdStar, MdOutlineAddTask, MdAddToQueue, MdClose, MdCopyAll, MdArrowBackIos } from 'react-icons/md';
import Headerworkstation from './header-workstation';
import Navbarwoarkstation from './Navbar-woarkstation';
import Projectstasklistws from './task_root/task-list-ws';
import Additem from './item_root/add-item';
import { Createitem } from './item_root/create_item';
import { Createtaskgroup } from './create_group_item';
import Itemlistws from './item_root/item-list-ws';
import Groupeditws from './group-edit-ws';
import TaskEditws from './task_root/task-edit-ws';
//shortble
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

//page links   
import './workstation.css';
import { FaRegPaste } from 'react-icons/fa6';
export default function Workstation({ data = {} }) {
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
  const dateRef = useRef(null);
  const duedateRef = useRef(null);
  const [puid, setpuid] = useState([]);
  const [taskuid, settaskuid] = useState([]);

  const [itemdata, setItemdata] = useState([]);
  const [groupname, setGroupname] = useState('');
  const [groupdata, setGroupdata] = useState([]);
  const [taskdata, setTaskdata] = useState([]);
  // 
  const [showTaskEdit, setShowTaskEdit] = useState(false);
  const [showAddItem, setShowAddItem] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedtask, setSelectedtask] = useState(false);
  //
  const capitalizeFirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  //
  useEffect(() => {
    setadminguid(Cookies.get("adminguid"));
    setpuid(searchParams.get('puid'));
    settaskuid(searchParams.get('taskuid'));

    const taskuid = searchParams.get('taskuid');
    if (taskuid !== null && taskuid !== '') {
      setSelectedtask(true);
    } else {
      setSelectedtask(false);
    }
  }, [searchParams]);
  //
  useEffect(() => {
    if (adminguid && puid && taskuid) {
      fetch_taskData();
    }
  }, [adminguid, puid, taskuid]);
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedToday = `${yyyy}-${mm}-${dd}`;
    if (dateRef.current) {
      dateRef.current.value = formattedToday;
    }
    if (duedateRef.current) {
      duedateRef.current.value = formattedToday;
    }

  }, []);

  //fetch_taskData
  const fetch_taskData = async () => {
    setIsLoading(true);
    try {
      // Fetch tasks
      const taskQuery = query(
        collection(db, "projectstask"),
        where("adminguid", "==", adminguid),
        where("puid", "==", puid),
        where("taskuid", "==", taskuid),
        where("status", "==", true)//,
        // orderBy("indexstage", "desc")
      );
      const taskSnapshot = await getDocs(taskQuery);
      const dataList = taskSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      // Fetch groups
      const groupQuery = query(
        collection(db, "projectstaskgroup"),
        where("adminguid", "==", adminguid),
        where("puid", "==", puid),
        where("taskuid", "==", taskuid),
        where("status", "==", true),
        orderBy("indexstage", "asc")
      );
      const groupSnapshot = await getDocs(groupQuery);
      const groupdataList = groupSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      // Prepare groupuids array for item query
      const groupuids = groupdataList.map(group => group.id);
      let itemdataList = [];
      if (groupuids.length > 0) {
        // Fetch items belonging to the fetched groups
        const itemQuery = query(
          collection(db, "projectstaskitem"),
          where("adminguid", "==", adminguid),
          where("puid", "==", puid),
          where("taskuid", "==", taskuid),
          where("groupuid", "==", groupuids),
          where("status", "==", true),
          orderBy("indexstage", "asc")
        );
        const itemSnapshot = await getDocs(itemQuery);
        itemdataList = itemSnapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data()
        }));
      }
      setTaskdata(dataList);
      setGroupdata(groupdataList);
      //  setItemdata(itemdataList);

    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && groupname.trim()) {
        create_group();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [groupname]);

  const create_group = async () => {
    if (!groupname.trim()) {
      showToast("Please enter groupname");
      setLoading(false);
      return;
    }
    if (!taskuid) {
      showToast("User taskuid missing.");
      setLoading(false);
      return;
    }

    if (!puid) {
      showToast("User puid missing.");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {

      const groupuid = Randomcode(19);
      const resultgroup = await Createtaskgroup({
        groupname: capitalizeFirst(groupname),
        puid,
        groupuid,
        taskuid,
        color: "#3B82F6",
        description: capitalizeFirst(groupname),
      });

      if (!resultgroup.success) {
        showToast("Failed to create task group: " + (resultgroup.error || "Unknown error"));
        return;
      }
      const timestamp = Timestamp.now();
      const itemuid = Randomcode(20);
      const resultitem = await Createitem({
        groupname: capitalizeFirst(groupname),
        groupuid,
        puid,
        itemuid,
        taskuid,

        due_date_time: timestamp,
        itemname: "Item name",
        color: "#3B82F6",
        description: capitalizeFirst(groupname),
      });

      if (resultitem.success) {
        fetch_taskData();
        setGroupname('');
        showToast("Group created successfully.");
      } else {
        showToast("Task created, but item failed: " + (resultitem.error || "Unknown error"));
      }

    } catch (ex) {
      console.error("An error occurred:", ex);
      showToast("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };


  //shi
  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!active || !over || active.id === over.id) return;
    const oldIndex = itemdata.findIndex((item) => item?.id === active.id);
    const newIndex = itemdata.findIndex((item) => item?.id === over.id);
    if (oldIndex === -1 || newIndex === -1) {
      console.warn("Drag item not found", { active, over });
      return;
    }
    const newOrder = arrayMove(itemdata, oldIndex, newIndex);
    setItemdata(newOrder);

    for (let i = 0; i < newOrder.length; i++) {
      const item = newOrder[i];
      const newIndexStage = newOrder.length - i; // descending
      if (item?.indexstage !== newIndexStage) {
        try {
          await updateDoc(doc(db, "projectstaskitem", item.id), {
            indexstage: newIndexStage,
          });
        } catch (err) {
          console.error(`Failed to update item ${item.id}:`, err);
        }
      }
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const task_close = () => {
    setSelectedtask(false);
    navigate('/' + puid);
  };
  return (
    <div>
      <Headerworkstation />
      <Helmet>
        <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>
        <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
        <meta name="keywords" content="job listings, freelance tasks, hire editors, creative work, India job portal, remote jobs, task board, EditorTask jobs" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Browse Job Tasks | EditorTask - Find & Hire Creative Talent" />
        <meta property="og:description" content="Explore freelance and project-based job tasks posted on EditorTask. Connect with skilled editors, designers, marketers, and more." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/jobs" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className='app_header_height'></div>
      <div className="container_roots">
        <div className="container_task_size">
          <div className='post-container'>

            {selectedtask ? (
              <div className='post_div pgrid'>
                <div className='Workstation-header'>
                  <table className='table-style' >
                    <tbody>
                      <tr>
                        <td width='30px'><MdArrowBackIos onClick={task_close} className='icon' /></td>


                        {showTaskEdit == true && (
                          <TaskEditws
                            data={data}
                            onClose={() => setShowTaskEdit(false)}
                          />
                        )}

                      <td>
  <div>
    <div className="projectname-text">
      {Array.isArray(taskdata) && taskdata.length > 0 ? taskdata[0].taskname : "Loading..."}
    </div>
    <br />
    <div style={{ marginTop: '-5px' }}>
      {data?.projectname ?? "Loading..."}
    </div>
  </div>
</td>
                        <td width='30px'><MdStar className='icon' /></td>
                        <td width='30px'><MdDisplaySettings className='icon' onClick={() => setShowTaskEdit(true)} // <-- Pass clicked group
                          title='Manage Task'
                        /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='tabws-body'>
                  <div className='tabsbutton active'>
                    <a className='tabs-text'>Main table</a>
                    <MdMoreHoriz className='tabicon' />
                  </div>
                  <div className='tabsbutton'>
                    <MdAdd className='tabicon' />
                  </div>
                </div>
                <br />

                <div className='task-group'>
                  {isLoading ? (
                    <Loading />
                  ) : groupdata.length === 0 ? (
                    <p>No group available.</p>
                  ) : (
                    <>
                      {groupdata.map((groups, index) => (
                        <div className='group-grid' key={index} style={{ borderLeft: `solid 4px ${groups.color}` }} >
                          <table className='table-style' >
                            <tbody>
                              <tr>
                                <td width='30px'>
                                  <MdMoreHoriz
                                    onClick={() => setSelectedGroup(groups)} // <-- Pass clicked group
                                    title='Edit Group'
                                    className='taskicon'
                                  />
                                  {selectedGroup?.groupuid === groups.groupuid && (
                                    <Groupeditws
                                      groups={selectedGroup}
                                      onClose={() => setSelectedGroup(null)}
                                    />
                                  )}
                                </td>
                                <td width='100%'>  <div className='task-title-input' style={{ color: groups.color }} >{groups.groupname}</div>
                                </td>
                                    <td width='25px'>
                                   <MdCopyAll
                                    title='CopyAll Group'
                                    className='taskicon'
                                  />
                                 </td>
                                      <td width='25px'>
                                   <FaRegPaste
                                    title='Paste Add new item'
                                    className='taskicon'
                                  />
                                 </td>

                                
                                <td width='20px'>
                                  <MdAddToQueue
                                    onClick={() => setShowAddItem(groups)}
                                    title='Add new item'
                                    className='taskicon'
                                  />

                                  {showAddItem?.groupuid === groups.groupuid && (
                                    <Additem
                                      groups={showAddItem}
                                      onClose={() => setShowAddItem(null)}
                                    />
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div className='table-grid'>
                            <Itemlistws data={{
                              puid: groups.puid,
                              groupuid: groups.groupuid,
                              taskuid: groups.taskuid, navigate
                            }} />
                          </div>

                          <br />
                        </div>

                      ))}

                    </>
                  )}
                </div>

                <div className='task-group'>
                  <div className='group-grid'>
                    <table  >
                      <tr>
                        <td width='150px'>
                          <input className='task-title-input' value={groupname} onChange={(e) => setGroupname(e.target.value)} placeholder='Create New Group' maxLength={30} type='text' />
                        </td>
                        <td>
                          <div className='button-ui1' onClick={create_group}> <MdAdd className='icon' />Add Group
                          </div>
                        </td>
                           
                                      <td width='25px'>
                                   <FaRegPaste
                                    title='Paste Add new item'
                                    className='taskicon'
                                  />
                                 </td>

                      </tr>
                    </table>
                  </div>

                </div>
              </div>
            ) : (
              <div className='post_div'>
                <Projectstasklistws data={data} />
              </div>

            )}
          </div>
        </div>
      </div>
      <Navbarwoarkstation />
    </div >
  );
}
